import { Input, Output, EventEmitter } from '@angular/core';
import { Getter } from './interfaces';
import { AMapShapeOverlay } from './amap-shape-overlay';
import { EventBinderService } from '../shared/event-binder.service';

export const CircleOptions = [
  'zIndex',
  'center',
  'bubble',
  'cursor',
  'radius',
  'strokeColor',
  'strokeOpacity',
  'strokeWeight',
  'fillColor',
  'fillOpacity',
  'strokeStyle',
  'extData',
  'strokeDasharray',
];

export class AMapCircle<T extends AMap.EventEmitter> extends AMapShapeOverlay<T> {
  // ---- Options ----
  /**
   * å±å é¡ºåºï¼é»è®¤zIndex:10
   */
  @Input() zIndex: number;
  /**
   * åå¿ä½ç½®
   */
  @Input() center: AMap.LocationValue;
  /**
   * ååå¾ï¼åä½:ç±³
   */
  @Input() radius: number;
  /**
   * çº¿æ¡é¢è²ï¼ä½¿ç¨16è¿å¶é¢è²ä»£ç èµå¼ãé»è®¤å¼ä¸º#006600
   */
  @Input() strokeColor: string;
  /**
   * è½®å»çº¿éæåº¦ï¼åå¼èå´[0,1]ï¼0è¡¨ç¤ºå®å¨éæï¼1è¡¨ç¤ºä¸éæãé»è®¤ä¸º0.9
   */
  @Input() strokeOpacity: number;
  /**
   * è½®å»çº¿å®½åº¦
   */
  @Input() strokeWeight: number;
  /**
   * åå½¢å¡«åé¢è²,ä½¿ç¨16è¿å¶é¢è²ä»£ç èµå¼ãé»è®¤å¼ä¸º#006600
   */
  @Input() fillColor: string;
  /**
   * åå½¢å¡«åéæåº¦ï¼åå¼èå´[0,1]ï¼0è¡¨ç¤ºå®å¨éæï¼1è¡¨ç¤ºä¸éæãé»è®¤ä¸º0.9
   */
  @Input() fillOpacity: number;
  /**
   * è½®å»çº¿æ ·å¼ï¼å®çº¿:solidï¼èçº¿:dashed
   */
  @Input() strokeStyle: AMap.StrokeStyle;
  /**
   * å¾åå½¢ç¶è½®å»çèçº¿åé´éçæ ·å¼
   */
  @Input() strokeDasharray: number[];

  /**
   * é¢å¤: æ¯å¦éè
   */
  @Input() hidden = false;
  /**
   * é¢å¤: æ¯å¦å¼å¯ç¼è¾å¨
   */
  @Input() editor = false;
  /**
   * é¢å¤: ä¼è¦çå¶ä»å±æ§çéç½®æ¹å¼
   */
  @Input() options: AMap.Polyline.Options;

  // directive events:
  @Output() naReady = new EventEmitter();

  constructor(protected os: Getter<T>, protected binder: EventBinderService) {
    super(os, binder);
  }
}
